module.exports = __webpack_public_path__ + "img/logo.b05c6e03.png";